import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c526c86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "prediction" }
const _hoisted_2 = { class: "predicted-bms" }
const _hoisted_3 = { class: "predicted-bms__value" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "predicted-bms__rank5proba"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_echo_inspection_upload = _resolveComponent("echo-inspection-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { justify: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { justify: "center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_echo_inspection_upload, { ref: "inspection" }, null, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, { justify: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.predict,
                              disabled: _ctx.isRunning
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" BMS推定 ")
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _withDirectives((_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.predictedBms ? _ctx.predictedBms : '?'), 1),
                _hoisted_4,
                (_ctx.predictedRank5Proba)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.predictedRank5Proba) + " % の確率で5等級です ", 1))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_loading, _ctx.isRunning]
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              "label-width": "200px",
              onKeyup: _withKeys(_ctx.search, ["enter"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { justify: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      xl: 6,
                      lg: 8,
                      md: 10,
                      sm: 12,
                      xs: 14
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "僧帽筋厚さ" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.searchTrapeziusThickness,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTrapeziusThickness) = $event)),
                              type: "number",
                              min: "0"
                            }, {
                              append: _withCtx(() => [
                                _createTextVNode("cm")
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "僧帽筋上皮下脂肪厚さ" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.searchTrapeziusSubcutaneousFatThickness,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTrapeziusSubcutaneousFatThickness) = $event)),
                              type: "number",
                              min: "0"
                            }, {
                              append: _withCtx(() => [
                                _createTextVNode("cm")
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "皮下脂肪厚さ" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.searchSubcutaneousFatThickness,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchSubcutaneousFatThickness) = $event)),
                              type: "number",
                              min: "0"
                            }, {
                              append: _withCtx(() => [
                                _createTextVNode("cm")
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "広背筋厚さ" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.searchLatissimusThickness,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchLatissimusThickness) = $event)),
                              type: "number",
                              min: "0"
                            }, {
                              append: _withCtx(() => [
                                _createTextVNode("cm")
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, { justify: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _ctx.search,
                          disabled: _ctx.predictedBms == null
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 保存 ")
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onKeyup"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}